<script lang="ts" setup>
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import SessionCard from './SessionCard.vue';
import SupportModal from './SupportModal.vue';
import { type SupportWorkFlow } from '@providers/support/supportWorkFlow';
import { SupportSessionStatus } from '@providers/support/support.type';

const { sessions } = defineProps<{
    sessions: SupportWorkFlow[];
}>();

const emit = defineEmits<{
    close: [];
    startSession: [SupportWorkFlow];
}>();

const historySessions = computed(() =>
    sessions.filter(
        ({ status }) =>
            status === SupportSessionStatus.Pending ||
            status === SupportSessionStatus.UnderReview ||
            status === SupportSessionStatus.Expired
    )
);
</script>

<template>
    <SupportModal inner title="لیست درخواست‌ها">
        <template #forward-action>
            <mr-button
                :icon-button="faChevronDown"
                size="small"
                variant="transparent"
                @click="emit('close')"
            />
        </template>
        <div class="sessions">
            <SessionCard
                v-for="session in historySessions"
                :key="session.sessionId"
                :session
                @start-session="emit('startSession', session)"
            />
        </div>
    </SupportModal>
</template>

<style lang="scss" scoped>
.sessions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 12px;
}
</style>
